﻿

$(document).ready(function () {

    let documentLang = $('html')[0].lang;
    let dataTableLangLocationUrl = "//" + window.location.hostname + "/Static/dist/scripts/jquery/vendor/language/dataTable_lang_" + documentLang + ".json";

    /**
     * @description List of seed form area field IDs
     * @type {string[]}
     */
    const seedFormAreaFieldIdList = ["SeedFormVm_Area1", "SeedFormVm_Area2", "SeedFormVm_Area3", "SeedFormVm_Area4", "SeedFormVm_Area5"];

    if (document.getElementsByClassName('seed-production-admin-form').length > 0) {
        // Add event listeners for each seed form area field
        for (let i = 0; i < seedFormAreaFieldIdList.length; ++i) {
            $(document).on('change', ('#' + seedFormAreaFieldIdList[i]), calculateSum);
        }

        if ($("#dtAdminContainer").length) {
            $("#dtAdminSeedForm").dataTable({
                "bFilter": true,
                "bServerSide": false,
                "aaSorting": [
                    [1, "asc"],
                    [2, "desc"]
                ],
                "aoColumnDefs": [
                    {
                        "bSortable": false,
                        "aTargets": [0]
                    }
                ],
                "iDisplayLength": 100,
                "aLengthMenu": [
                    [50, 100, 200, -1],
                    [50, 100, 200, "All"]
                ],
                "oLanguage": {
                    "sUrl": dataTableLangLocationUrl
                }
            });
        }
    }

    if (document.getElementsByClassName('grass-seed-production-admin-form').length > 0) {
        // Add event listeners for each grass seed form area field
        // for (let i = 0; i < seedFormAreaFieldIdList.length; ++i) {
        //     $(document).on('change', ('#' + seedFormAreaFieldIdList[i]), calculateSum);
        // }

        if ($("#dtAdminContainer").length) {
            $("#dtGrassSeedAdmin").dataTable({
                "bFilter": true,
                "bServerSide": false,
                "aaSorting": [
                    [1, "asc"],
                    [2, "desc"]
                ],
                "aoColumnDefs": [
                    {
                        "bSortable": false,
                        "aTargets": [0]
                    }
                ],
                "iDisplayLength": 100,
                "aLengthMenu": [
                    [50, 100, 200, -1],
                    [50, 100, 200, "All"]
                ],
                "oLanguage": {
                    "sUrl": dataTableLangLocationUrl
                }
            });
        }
    }

    /**
     * @description Function to remove event listeners
     */
    function removeEventListeners() {
        for (let i = 0; i < seedFormAreaFieldIdList.length; ++i) {
            $(document).off('change', ('#' + seedFormAreaFieldIdList[i]), calculateSum);
        }
    }

    removeEventListeners(); // Remove event listeners
});

/**
 * @description Function to calculate the sum of seed form areas
 */
function calculateSum() {
    const seedFormAreaFieldIdList = ["SeedFormVm_Area1", "SeedFormVm_Area2", "SeedFormVm_Area3", "SeedFormVm_Area4", "SeedFormVm_Area5"];
    var sum = 0;

    for (let i = 0; i < seedFormAreaFieldIdList.length; ++i) {
        var value = $('#' + seedFormAreaFieldIdList[i]).val();
        var parsedValue = parseFloat(value);
        if (value != 'undefined' && value != '' && !isNaN(value)) {
            sum = sum + parsedValue;
        }
    }

    $('#SeedFormVm_CustomerTotalArea').val('');
    $('#SeedFormVm_CustomerTotalArea').val(sum);
}
